import gql from 'graphql-tag'

export default gql`
query getregistrationCount($slug: String, $province: String){
  registrationCount(filter: {
    AND:[{slug : $slug},{profile:{province: $province}}]
  })
}
`
